import { getSafeColor } from "services/utils";

function navbar(theme, ownerState) {
  const { palette, functions, transitions, breakpoints } = theme;
  const { absolute, darkMode } = ownerState;

  const { navBar } = palette;
  const { rgba, pxToRem } = functions;

  const navbarAlpha = 0.98;
  const navbarColor = navBar.main;

  return {
    width: "100%",
    margin: 0,
    left: 0,
    right: 0,
    position: absolute ? "absolute" : "sticky",
    top: 0,
    zIndex: 1200,

    height: pxToRem(64),
    overflow: "visible !important",
    display: "flex",
    alignItems: "center",

    // 📱 MOBILE FIX: Full width on small screens (375px)
    [breakpoints.down("sm")]: {
      width: "100%",
      margin: 0,
      top: 0,
      borderRadius: 0,
    },

    // 🖥️ LARGE SCREEN: Existing logic
    [breakpoints.up("xl")]: {
      width: "100%",
      margin: 0,
      top: 0,
      height: pxToRem(64),
    },

    backgroundColor: `${rgba(getSafeColor(navbarColor), navbarAlpha)} !important`,

    backdropFilter: "none",
    WebkitBackdropFilter: "none",

    color: getSafeColor(navBar.contrastText),

    borderRadius: 0,
    border: "none",
    borderBottom: `1px solid ${rgba(getSafeColor(navBar.contrastText), darkMode ? 0.1 : 0.14)}`,
    boxShadow: "none",

    transition: transitions.create(["all"], {
      easing: transitions.easing.easeInOut,
      duration: transitions.duration.standard,
    }),

    "& .MuiToolbar-root": {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      width: "100%",
      height: "100%",
      padding: `0 ${pxToRem(16)}`,

      [breakpoints.up("xl")]: {
        padding: `0 ${pxToRem(24)}`,
      },
    },

    "& .MuiIcon-root, & .MuiSvgIcon-root": {
      color: "inherit",
    },
  };
}

const navbarContainer = ({ breakpoints }) => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "space-between",
  width: "100%",
  gap: 2, // Default gap

  // 📱 MOBILE FIX: Reduce gap to prevent overflow
  [breakpoints.down("sm")]: {
    gap: 1,
    paddingRight: 1, // Ensure rightmost button isn't flush with edge
  },

  [breakpoints.down("md")]: {
    flexDirection: "row",
  },
});

const navbarRow = ({ breakpoints }, { isMini }) => ({
  display: "flex",
  alignItems: "center",
  gap: 1.5, // Even spacing between elements

  [breakpoints.up("md")]: {
    justifyContent: isMini ? "space-between" : "stretch",
    width: "max-content",
  },
});

const navbarIconButton = (theme, { breakpoints }) => ({
  width: 42,
  height: 42,

  borderRadius: "12px",

  color: theme.palette.navBar.contrastText,

  border: `1px solid ${theme.functions.rgba(theme.palette.navBar.contrastText, 0.12)}`,

  backgroundColor: theme.functions.rgba(theme.palette.navBar.contrastText, 0.04),

  transition: "all 0.2s ease",

  "&:hover": {
    backgroundColor: theme.functions.rgba(theme.palette.navBar.contrastText, 0.1),

    borderColor: theme.functions.rgba(theme.palette.navBar.contrastText, 0.25),

    transform: "translateY(-1px)",
  },

  "& .material-icons, .material-icons-round": {
    fontSize: `${theme.functions.pxToRem(20)} !important`,
  },

  "& .MuiTypography-root": {
    display: "none",

    [breakpoints.up("sm")]: {
      display: "inline-block",
      fontSize: "0.875rem",
      fontWeight: 500,
      ml: 0.75,
    },
  },
});

const navbarFilterControl = (theme) => ({
  height: 42,
  minWidth: 110,

  borderRadius: "12px",

  border: `1px solid ${theme.functions.rgba(theme.palette.navBar.contrastText, 0.12)}`,

  backgroundColor: theme.functions.rgba(theme.palette.navBar.contrastText, 0.04),

  color: `${theme.palette.navBar.contrastText} !important`,

  fontSize: "0.85rem",
  fontWeight: 600,

  transition: "all 0.2s ease",

  "&:hover": {
    backgroundColor: theme.functions.rgba(theme.palette.navBar.contrastText, 0.08),

    borderColor: theme.functions.rgba(theme.palette.navBar.contrastText, 0.22),
  },

  "& .MuiSelect-select": {
    display: "flex",
    alignItems: "center",
    padding: "0 14px",
    minHeight: "42px !important",
  },

  "& .MuiSvgIcon-root": {
    color: theme.palette.navBar.contrastText,
    opacity: 0.8,
  },
});

const navbarMobileMenu = ({ breakpoints }) => ({
  display: "inline-block",
  lineHeight: 0,
  mr: 1,

  [breakpoints.up("xl")]: {
    display: "none",
  },
});

export {
  navbar,
  navbarContainer,
  navbarRow,
  navbarIconButton,
  navbarFilterControl,
  navbarMobileMenu,
};
